/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Ping
} from './schema'



/**
 * Test API Connectivity to Access API and retrieve server time
 * @summary Test connectivity
 */
export const pingGet = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Ping>> => {
    return axios.get(
      `/ping`,options
    );
  }


export const getPingGetQueryKey = () => [`/ping`];

    
export type PingGetQueryResult = NonNullable<Awaited<ReturnType<typeof pingGet>>>
export type PingGetQueryError = AxiosError<unknown>

export const usePingGet = <TData = Awaited<ReturnType<typeof pingGet>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pingGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPingGetQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pingGet>>> = ({ signal }) => pingGet({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof pingGet>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Test API Connectivity to Access API and retrieve server time
 * @summary Test connectivity
 */
export const pingPost = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Ping>> => {
    return axios.post(
      `/ping`,undefined,options
    );
  }



    export type PingPostMutationResult = NonNullable<Awaited<ReturnType<typeof pingPost>>>
    
    export type PingPostMutationError = AxiosError<unknown>

    export const usePingPost = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pingPost>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pingPost>>, TVariables> = () => {
          

          return  pingPost(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof pingPost>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    